import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faFlask, faComments, faAtom } from "@fortawesome/free-solid-svg-icons";
import "../styles/ProgressCard.css";
import imagenesMaterias from "../utils/imagenesMaterias";

function ProgressCard({ title, color, fontColor, icon, completed, total }) {
  const porcentaje = Math.round((completed / total) * 100);

  const imageSrc = imagenesMaterias[icon.replace("ic_", "")] || imagenesMaterias["default"];
  return (
    <div className="progress-card-materia">
      <div className="card-header-materia">
        <div
          className="card-img-materia"
          style={{ backgroundColor: color }}
        >
          <img src={imageSrc} alt={title} className="card-icon-materia" />
        </div>
      </div>
      <div className="w-100 px-3">
        <h3>{title}</h3>
        <p>
          Temas: {completed}/{total} — {porcentaje}%
        </p>
        <div className="progress-bar-materia">
          <div
            className="progress-fill-materia"
            style={{ width: `${porcentaje}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default ProgressCard;
